import { getBackboneWindow } from '@opallabs/brown-dwarf'

// Resolve one flag against the layers the server writes onto the page. Read
// live rather than from a precomputed map: the workspace layer isn't
// necessarily populated when a bundle boots, so a cached map can outlive the
// data it was built from.
const resolveFeature = (backboneWindow, feature) => {
  const app = backboneWindow?.application_features || {}

  // `application_features` carries every available flag along with its default,
  // so a name that's missing from it is a name the opal doesn't recognize. The
  // other layers are overrides, not additions.
  if (!(feature in app)) return false

  const override = [
    backboneWindow.user_features,
    backboneWindow.workspace_features,
    backboneWindow.plan_features,
  ].find((layer) => layer && feature in layer)

  return (override ? override[feature] : app[feature]) || false
}

const testFeature = (feature = '') => {
  if (feature.constructor !== String) {
    console.warn(
      `${feature} is a ${feature.constructor}; it needs to be a string to be valid.`
    )
  }

  return resolveFeature(getBackboneWindow(), feature)
}

export const makeFeatureSet = () => {
  const backboneWindow = getBackboneWindow()

  return Object.keys(backboneWindow?.application_features || {}).reduce(
    (acc, feature) => ({
      ...acc,
      [feature]: resolveFeature(backboneWindow, feature),
    }),
    {}
  )
}

export { testFeature }
